import { useEffect, useState } from 'react';

/**
 * A janela está mais estreita que `px`? Reage na hora em que a largura cruza o
 * limite (matchMedia), sem precisar recarregar.
 */
export function useLarguraAbaixoDe(px: number): boolean {
  const consulta = `(max-width: ${px - 1}px)`;
  const [abaixo, setAbaixo] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(consulta).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const mudou = (): void => setAbaixo(mq.matches);
    mudou();
    mq.addEventListener('change', mudou);
    return () => mq.removeEventListener('change', mudou);
  }, [consulta]);
  return abaixo;
}
